import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, message} from 'antd';
import {Route, Switch} from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import {getResource, handleSelectAssetSubType, handleSelectAssetType} from '../../appRedux/actions/PreVerification'
import {
  clearPropsData,
  createResource,
  fetchResource,
  getPreVerificationApprovalResource,
  getResourceForDownload,
  saveResourceQuery,
} from '../../appRedux/actions/PreVerificationApproval';
import {fetchFilter, fetchSubDocumentFilter} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import * as _ from 'lodash';
import axios from 'util/Api';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from "moment";

export class PreVerificationApproval extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  isImageUploading = (e) => {
    const {astUploadCount} = this.props;
    if (astUploadCount) {
      e.preventDefault();
      e.returnValue = `Images are Uploading. Please do not close the window until it get's completed`;
      return 'Images are Uploading';
    }
    return true;
  }

  setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", this.isImageUploading);
  };

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
    //this.setupBeforeUnloadListener();
  }

  // componentWillUnmount() {
  //   window.removeEventListener("beforeunload", this.isImageUploading);
  // }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({
        visibleColumns: columns
      }, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const {filters} = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  checkResource = (values) => {
    this.props.checkResource(values);
  };

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const {resourceName} = this.props;

    Object.keys(filters).forEach((item) => {

      if (item === '_id') {
        return;
      }

      if (selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record, ...data) => (
        <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="primary" style={{width: '50px'}} size='small'
                           onClick={() => this.view(record._id)}>View</Button>
          }}/>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'r'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="default" style={{marginLeft: '10px', width: '70px'}} size='small'
                           onClick={() => this.download(record._id)}>Download</Button>
          }}/>
        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getPreVerificationApprovalResource();
  };

  createResource = (values, update = false) => {
    this.props.createResource(values, update);
  };

  createResourceWithDocuments = (values, checked, update = false, secondUpdate = false, save = false) => {
    this.props.createResourceWithDocuments(values, checked, update, secondUpdate, save);
  };

  updateResource = (values, id, checked, update = false, save = false) => {
    this.props.updateResource(values, id, checked, update, save);
  };

  submitReport = (id) => {
    this.props.submitReport(id);
  }

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  view = (id) => {
    const {match} = this.props;
    this.props.getPreVerificationApprovalResource();
    this.props.history.push(`${match.url}/view/${id}`);
  };

  download = async (id) => {
    const response = await axios.get(`/pre-verification-approval/download-asset-code/${id}`);
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    if(response && response.data && response.data.assetDetails) {
      let arr = [];
      for(let i = 0; i < response.data.assetDetails.length; i++) {
        let item = response.data.assetDetails[i];
        let obj = {};
        obj.Sno = i+1;
        obj.pvNo = response.data.pvNo && response.data.pvNo.pvNo || '';
        obj.pvAppNo = response.data.pvAppNo || '';
        obj.assetType = item.assetType && item.assetType.name || '';
        obj.equipmentSubType = item.equipmentSubType && item.equipmentSubType.name || '';
        obj.assetModel = item.assetModel && item.assetModel.name || '';
        obj.countable = item.countable ? 'true' : 'false';
        obj.assetCustodian = item.assetCustodian && item.assetCustodian.name || '';
        obj.serialNumber = item.serialNumber || '';
        obj.utilisationLevel = item.utilisationLevel || '';
        obj.invoiceDate = item.invoiceDate || '';
        obj.quantity = item.qty || '';
        obj.rate = item.rate || '';
        obj.physicalCondition = item.physicalCondition && item.physicalCondition.name || '';
        obj.ownedBy = item.ownedBy && item.ownedBy.name || '';
        obj.tempAssetCode = item.tempAssetCode || '';
        obj.assetCode = (item.assetCode).toString() || '';
        obj.createdBy = response.data.createdBy && response.data.createdBy.name || '';
        obj.createdAt = moment(response.data.createdAt).format('MMMM Do YYYY, h:mm:ss a');
        arr.push(obj);
      }
      const ws = XLSX.utils.json_to_sheet(arr);
      const wb = {Sheets: {report: ws}, SheetNames: ['report']};
      const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
      const data = new Blob([excelBuffer], {type: fileType});
      FileSaver.saveAs(
        data,
        `PreVerificationApprovalReport-${Date.now()}${fileExtension}`,
      );
    }
  };

  report = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/difference-report/${id}`);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "PreVerificationApproval");
  }

  updateTempCode = (id, payload, checked, update) => {
    this.props.updateTempCode(id, payload, checked, update);
  }

  getResource = () => {
    this.props.getResource(true);
  }

  render() {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName} = this.props;
    const {columns, visibleColumns} = this.state;
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>{sanitizeFieldName(resourceName)}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
               render={() => <List columns={columns}
                                   data={data}
                                   clearFilter={this.clearAll}
                                   filters={filters}
                                   handleChange={this.handleChange}
                                   columnChange={this.handleColumnChange}
                                   downloadToCSV={this.downloadToCSV}
                                   title={resourceName}
                                   size={'middle'}
                                   create={this.create}
                                   pagination={this.props.query.pagination}
                                   loading={loading}
                                   authUser={authUser}
                                   visibleColumn={visibleColumns}
               />
               }/>
        <Route path={`${match.url}/add`}
               render={(props) => <Create
                 pvData={this.props.pvData}
                 filters={filters}
                 data={this.props.data}
                 findAllPvNo={this.getResource}
                 record={this.props.record}
                 subDocumentFilters={this.props.subDocumentFilters}
                 handleSelectAssetType={this.props.handleSelectAssetType}
                 handleSelectAssetSubType={this.props.handleSelectAssetSubType}
                 assetSubTypes={this.props.assetSubTypes}
                 clearData={this.props.clearPropsData}
                 assetModels={this.props.assetModels}
                 match={match}
                 onTempCodeUpdate={this.updateTempCode}
                 tempCodeData={this.props.resource}
                 history={this.props.history}
                 modules={modules}
                 title={'CREATE'}
                 resource={resourceName}
                 onChange={this.handleFormChange}
                 onUpdate={this.updateResource}
                 warning={this.props.warning}
                 onSubmit={this.createResource}
                 loading={loading}
                 {...props}
               />
               }/>
        <Route path={`${match.url}/view/:id`}
               render={(props) => <Create data={edit}
                                          filters={filters}
                                          pvData={this.props.pvData}
                                          findAllPvNo={this.getResource}
                                          subDocumentFilters={this.props.subDocumentFilters}
                                          handleSelectAssetType={this.props.handleSelectAssetType}
                                          handleSelectAssetSubType={this.props.handleSelectAssetSubType}
                                          assetSubTypes={this.props.assetSubTypes}
                                          clearData={this.props.clearPropsData}
                                          assetModels={this.props.assetModels}
                                          match={match}
                                          fetch={fetchResource}
                                          onTempCodeUpdate={this.updateTempCode}
                                          tempCodeData={this.props.resource}
                                          history={this.props.history}
                                          modules={modules}
                                          title={'VIEW'}
                                          resource={resourceName}
                                          onChange={this.handleFormChange}
                                          loading={loading}
                                          {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({auth, preVerification, preVerificationApproval, commonData}) => {
  return {
    authUser: auth.authUser,
    total: preVerificationApproval.total,
    pvData: preVerification.resources,
    data: preVerificationApproval.preApprovalResources,
    resource: preVerification.resource,
    edit: preVerificationApproval.edit,
    query: preVerificationApproval.query,
    warning: preVerification.warning,
    assetSubTypes: preVerification.assetSubTypes,
    assetModels: preVerification.assetModels,
    astUploadCount: preVerification.astUploadCount,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    subDocumentFilters: commonData.subDocumentFilters
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getPreVerificationApprovalResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    getResource,
    saveResourceQuery,
    fetchFilter,
    fetchSubDocumentFilter,
    clearPropsData,
    handleSelectAssetType,
    handleSelectAssetSubType,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(PreVerificationApproval);
